histories-approval-required-to-seller
  span.event {this.locale().event}
  script(type="typescript").
    this.mixin('histories.base');
